import * as dompack from 'dompack';
var $todd = require("./support");
import { Element, Class, typeOf } from "@webhare-system/frameworks/mootools/core";

/****************************************************************************************************************************
 *                                                                                                                          *
 *  SPLIT                                                                                                                   *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjSplit = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "split"
, parts: []
, horizontal:null

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);
    this.horizontal = data.horizontal;

    this.parts = data.items.map(item => this.owner.addComponent(this, item));
    this.buildNode();

    this.node.addEvents({ "movestart": this.onMoveStart.bind(this)
                        , "move": this.onMove.bind(this)
                        , "moveend": this.onMoveEnd.bind(this)
                        });
  }


/****************************************************************************************************************************
* Component management
*/

, getVisibleChildren:function()
  {
    return this.parts;
  }

, readdComponent: function(comp)
  {
    // Replace the offending component
    //if(!comp.parentsplititem)
    if(comp.parentcomp != this)
      return console.error('Child ' + comp.name + ' not inside the split is trying to replace itself');

    var newcomp = this.owner.addComponent(this, comp.name);
    this.parts.splice(this.parts.indexOf(comp), 1, newcomp);

    dompack.replaceWith(comp.getNode(), newcomp.getNode());
  }

/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element("t-split", { "data-name": this.name
                                       });
    this.node.store("todd", this);

    this.node.classList.add(this.horizontal ? "horizontal" : "vertical");

    this.splitters = [];
    this.parts.forEach( (part, idx) =>
    {
      if (idx>0)
      {
        let splitter = dompack.create('div', { className: "splitter" });
        splitter.set('movable','true'); //compat/dragdrop REQUIRES this to be done through Moo
        this.splitters.push(splitter);
        this.node.appendChild(splitter);
      }
      this.node.appendChild(part.getNode());
    });
  }


/****************************************************************************************************************************
* Dimensions
*/
, calculateDimWidth: function()
  {
    if(this.horizontal)
    {
      this.setSizeToSumOf('width', this.parts);
      this.width.splitters = this.splitters.length ? this.splitters[0].getSize().x * this.splitters.length : 0;
      this.width.min += this.width.splitters;
      this.width.calc += this.width.splitters;
    }
    else
    {
      this.setSizeToMaxOf('width', this.parts);
    }
  }

, applySetWidth: function()
  {
    if (this.horizontal)
      this.distributeSizeProps('width', this.width.set - this.width.splitters, this.parts, true, this.parts.length-1);
    else
      this.parts.invoke('setWidth', this.width.set);
  }

, calculateDimHeight: function()
  {
    if(this.horizontal)
    {
      this.setSizeToMaxOf('height', this.parts);
    }
    else
    {
      this.setSizeToSumOf('height', this.parts);
      this.height.splitters = this.splitters.length ? this.splitters[0].getSize().y * this.splitters.length : 0;
      this.height.min += this.height.splitters;
      this.height.calc += this.height.splitters;
    }
  }

, applySetHeight: function()
  {
    if (this.horizontal)
      this.parts.invoke('setHeight', this.height.set);
    else
      this.distributeSizeProps('height', this.height.set - this.height.splitters, this.parts, false, this.parts.length-1);
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    var setwidth = Math.max(this.width.min, this.width.set);
    var setheight = Math.max(this.height.min, this.height.set);
    this.node.setStyles({ width: setwidth
                        , height: setheight
                        });

    if(this.horizontal)
      this.splitters.invoke('setStyle', 'height', setheight);
    else
      this.splitters.invoke('setStyle', 'width', setwidth);
    this.parts.invoke('relayout');
  }

, distributeSizeProps: function(property, available, items, horizontal, leftoverobj)
  {
    // If we're resizing two split parts by moving a splitter, only redistribute the sizes of the affected parts
    if (typeOf(this.movesplitter) != "null")
    {
      items = items.filter(function(item, idx)
      {
        // This part is affected if it's the part before the splitter or after the splitter (splitter 0 is located between part
        // 0 and part 1)
        var affected = idx == this.movesplitter || idx == this.movesplitter + 1;
        // If this part is not affected, it keeps its size
        if (!affected)
          available -= item[property].set;
        return affected;
      }, this);
      // The last affected part is the new leftover object
      leftoverobj = items.length - 1;
    }
    // Call the original distributeSizeProps
    return this.parent(property, available, items, horizontal, leftoverobj);
  }


/****************************************************************************************************************************
* Events
*/

, onMoveStart: function(event)
  {
    if (event.rightClick)
    {
      event.stop();
      return;
    }

    var dragtarget = dompack.closest(event.target, "[movable]");
    //console.log(event.target, dragtarget);
    if (!dragtarget)
    {
      event.stop();
      return;
    }

    var idx = this.node.getElements(">[movable]").indexOf(dragtarget);
    var splittersize = dragtarget.getSize()[ this.horizontal ? "x": "y" ];

    var prevcomp = dragtarget.previousSibling.retrieve("todd");
    var nextcomp = dragtarget.nextSibling.retrieve("todd");

    var coords = dragtarget.getCoordinates(this.node);
    var pos = { height: this.horizontal ? coords.height : splittersize
              , left: coords.left + (this.horizontal ? Math.floor((coords.width - splittersize) / 2) : 0)
              , top: coords.top + (this.horizontal ? 0 : Math.floor((coords.height - splittersize) / 2))
              , width: this.horizontal ? splittersize : coords.width
              };
    var min = this.horizontal ? dragtarget.previousSibling.getPosition(this.node).x + prevcomp.width.min
                              : dragtarget.previousSibling.getPosition(this.node).y + prevcomp.height.min;
    var max = this.horizontal ? dragtarget.nextSibling.getPosition(this.node).x + dragtarget.nextSibling.getSize(this.node).x - splittersize - nextcomp.width.min
                              : dragtarget.nextSibling.getPosition(this.node).y + dragtarget.nextSibling.getSize(this.node).y - splittersize - nextcomp.height.min;

    var mover = (new Element("div", { "class": "movingsplitter"
                                    , styles: { height: pos.height
                                              , left: pos.left
                                              , top: pos.top
                                              , width: pos.width
                                              }
                                    })).inject(this.node);

    this.draginfo = { initial: pos
                    , lastpos: event.moved
                    , minpos: min
                    , maxpos: max
                    , prevcomp: prevcomp
                    , nextcomp: nextcomp
                    , splitter: idx
                    , mover: mover
                    };
    event.stopPropagation();
  }

, onMove: function(event)
  {
    if (!this.draginfo)
      return; // Nothing to drag
    if (typeof event.moved.x == "undefined")
      return; // May happen in IE, which has its own move event
    if ($todd.SizeEqual(this.draginfo.lastpos, event.moved))
      return;
    this.draginfo.lastpos = event.moved;

    if (this.horizontal)
      this.draginfo.mover.setStyle("left", Math.min(Math.max(this.draginfo.initial.left + event.moved.x, this.draginfo.minpos), this.draginfo.maxpos));
    else
      this.draginfo.mover.setStyle("top", Math.min(Math.max(this.draginfo.initial.top + event.moved.y, this.draginfo.minpos), this.draginfo.maxpos));
  }

, onMoveEnd: function(event)
  {
    if (!this.draginfo)
      return;

    var diff = this.horizontal ? this.draginfo.mover.getStyle("left").toInt() - this.draginfo.initial.left
                               : this.draginfo.mover.getStyle("top").toInt() - this.draginfo.initial.top;
    if (diff)
    {
      if (this.horizontal)
      {
        this.draginfo.prevcomp.setNewWidth(this.draginfo.prevcomp.width.set + diff);
        this.draginfo.nextcomp.setNewWidth(this.draginfo.nextcomp.width.set - diff);
      }
      else
      {
        this.draginfo.prevcomp.setNewHeight(this.draginfo.prevcomp.height.set + diff);
        this.draginfo.nextcomp.setNewHeight(this.draginfo.nextcomp.height.set - diff);
      }
      this.movesplitter = this.draginfo.splitter;
      this.owner.recalculateDimensions();
      this.owner.relayout();
      this.movesplitter = null;
    }

    this.draginfo.mover.destroy();
    this.draginfo = null;
  }

});


/****************************************************************************************************************************
 *                                                                                                                          *
 *  BUTTONGROUP                                                                                                             *
 *                                                                                                                          *
 ****************************************************************************************************************************/


$todd.ObjButtonGroup = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "buttongroup"
, borders: {}

/****************************************************************************************************************************
* Initialization
*/

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);

    this.layout = data.layout;
    this.borders = data.borders;

    this.buttons = [];
    data.buttons.forEach(button =>
    {
      var comp = this.owner.addComponent(this, button);
      if (!comp.getNode())
        return; //ignore this component for further consideration

      this.buttons.push(comp);
    });

    this.buildNode();
  }


/****************************************************************************************************************************
* Component management
*/

, readdComponent: function(comp)
  {
    // Replace the offending component
    //if(!comp.parentsplititem)
    if(comp.parentcomp != this)
      return console.error('Child ' + comp.name + ' not inside the buttongroup is trying to replace itself');

    var newcomp = this.owner.addComponent(this, comp.name);
    this.buttons.splice(this.buttons.indexOf(comp), 1, newcomp);
    dompack.replaceWith(comp.getNode(), newcomp.getNode());
  }

/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = dompack.create("t-buttongroup", { dataset: {name: this.name}
                                                , className: this.layout
                                                });
    this.node.store("todd", this);

    this.separators = [];
    this.buttons.forEach((button, idx) =>
    {
      if (idx>0)
      {
        let separator = dompack.create("div", { className: "separator"
                                              , childNodes: [dompack.create('div')]
                                              });
        this.node.appendChild(separator);
        this.separators.push(separator);
      }
      this.node.appendChild(button.getNode());
    });

    Array.forEach(['top','bottom','left','right'], dir =>
    {
      if(this.borders && this.borders[dir])
        this.node.classList.add("border-" + dir);
    });
  }


/****************************************************************************************************************************
* Dimensions
*/
, getVisibleChildren: function()
  {
    return this.buttons;
  }

, calculateDimWidth: function()
  {
    var contentwidth = 0;
    this.buttons.each(function(button)
    {
      if (this.layout == "horizontal")
        contentwidth += button.width.calc;
      else
        contentwidth = Math.max(contentwidth, button.width.calc);
    }, this);

    // Width of separators for horizontal group
    this.width.separators = this.layout == "horizontal" && this.separators.length ? this.separators[0].getSize().x * this.separators.length : 0;

    // Check if a specific width is set in XML
    var width = $todd.ReadSetWidth(this.width);
    // Calculate needed size
    contentwidth += this.width.separators;
    this.width.calc = Math.max(contentwidth, width);

    this.width.overhead = (this.borders && this.borders.left ? $todd.settings.border_left : 0) +
                        + (this.borders && this.borders.right ? $todd.settings.border_right : 0);

    this.width.min += this.width.overhead;
    this.width.calc += this.width.overhead;

    this.debugLog("dimensions", "contentwidth=" + contentwidth + ", calc=" + this.width.calc + ", min=" + this.width.min + ", separators=" + this.width.separators);
  }

, applySetWidth: function()
  {
    var setwidth = Math.max(this.width.min, this.width.set) - this.width.separators - this.width.overhead;
    this.debugLog("dimensions", "min=" + this.width.min + ", calc=" + this.width.calc + ", set width=" + this.width.set + ", separators=" + this.width.separators);

    if (this.layout == "horizontal")
      this.distributeSizeProps('width', setwidth, this.buttons, true);
    else
      this.buttons.invoke('setWidth', setwidth);
  }
, calculateDimHeight: function()
  {
    this.debugLog("dimensions", "Recalculating height");

    var contentheight = 0;
    this.buttons.each(function(button)
    {
      if (this.layout == "horizontal")
        contentheight = Math.max(contentheight, button.height.calc);
      else
        contentheight += button.height.calc;
    }, this);

    // Height of separators for vertical group
    this.height.separators = this.layout == "horizontal" ? 0 : this.separators.length ? this.separators[0].getSize().y * this.separators.length : 0;

    // Check if a specific height is set in XML
    var height = $todd.ReadSetHeight(this.height);
    // Calculate needed size
    contentheight += this.height.separators;
    this.height.calc = Math.max(contentheight, height);

    this.height.overhead = (this.borders && this.borders.top ? $todd.settings.border_top : 0) +
                         + (this.borders && this.borders.bottom ? $todd.settings.border_bottom : 0);

    this.debugLog("dimensions", "contentheight=" + contentheight + ", calc=" + this.height.calc + ", min=" + this.height.min + ", separators=" + this.height.separators);
  }

, applySetHeight: function()
  {
    var setheight = Math.max(this.height.min, this.height.set) - this.height.separators - this.height.overhead;
    this.debugLog("dimensions", "min=" + this.height.min + ", calc=" + this.height.calc + ", set height=" + this.height.set + ", separators=" + this.width.separators);

    if (this.layout == "horizontal")
      this.buttons.invoke('setHeight', setheight);
    else
      this.distributeSizeProps('height', setheight, this.buttons, false);
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);

    var setwidth = Math.max(this.width.min, this.width.set);
    var setheight = Math.max(this.height.min, this.height.set);

    if(this.layout == "horizontal")
    {
      this.node.setStyles({ "width": setwidth
                          , "height": this.height.calc
                          , "margin-top": this.getVerticalPosition()
                          });
    }
    else
    {
      this.node.setStyles({ "height": setheight
                          , "width": this.width.calc
                          , "margin-top": this.getVerticalPosition()
                          });
    }

    this.buttons.invoke('relayout');
  }
});


/****************************************************************************************************************************
 * Export the components
 */
exports.components = { split: $todd.ObjSplit
                     , buttongroup: $todd.ObjButtonGroup
                     };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/containers.es